import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router';

interface SurfaceToggleProps {
  active: 'case' | 'ssb';
  caseId?: string | number;
}

const pillSx = (isActive: boolean) => ({
  borderRadius: '6px',
  fontSize: '13px',
  paddingX: '14px',
  whiteSpace: 'nowrap',
  ...(isActive
    ? {
        backgroundColor: '#fff',
        border: '1px solid #CBD5E0',
        color: '#1A202C',
        fontWeight: 600,
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
      }
    : { color: '#4A5568', fontWeight: 500 }),
});

// regular case and ssb switch
function SurfaceToggle({ active, caseId }: SurfaceToggleProps) {
  const navigate = useNavigate();

  const caseSuffix = caseId ? `/${caseId}` : '';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        backgroundColor: '#EDF2F7',
        borderRadius: '8px',
        padding: '4px',
      }}
    >
      <Button
        size='small'
        sx={pillSx(active === 'case')}
        onClick={active === 'case' ? undefined : () => navigate(`/case-details${caseSuffix}`)}
      >
        Discovery Snapshot
      </Button>
      <Button
        size='small'
        sx={pillSx(active === 'ssb')}
        onClick={active === 'ssb' ? undefined : () => navigate(`/similarly-situated-builder${caseSuffix}`)}
      >
        Prima Facie Analysis
      </Button>
    </Box>
  );
}

export default SurfaceToggle;
